// src/components/doctor/VisitStepper.jsx
//
// Tier 2 — the four-step bar. It is both progress (✓ once a step is complete)
// and navigation (any step, any order: autosave means nothing is forced).
// A <nav> of buttons with aria-current="step" on the open one.

import React from 'react';
import { STEPS } from '../../utils/consultSteps';

export default function VisitStepper({ current, states, subtitles, onSelect }) {
  return (
    <nav aria-label="Consultation steps" data-testid="visit-stepper">
      <ol className="consult-steps">
        {STEPS.map((s, i) => {
          const state = states[s.key];
          const on = s.key === current;
          const done = state === 'done';
          return (
            <li key={s.key}>
              <button type="button" className={`consult-step${on ? ' consult-step--on' : ''}${done ? ' consult-step--done' : ''}`}
                aria-current={on ? 'step' : undefined} onClick={() => onSelect(s.key)}
                aria-label={`${s.label}${done ? ' (complete)' : state === 'optional' ? ' (optional)' : ''}`}>
                <span className="consult-step__n" aria-hidden="true">{done ? '✓' : i + 1}</span>
                <span className="consult-step__text">
                  <span className="consult-step__full">{s.label}</span>
                  <span className="consult-step__short">{s.short}</span>
                  <span className="consult-step__sub">{subtitles[s.key] || ' '}</span>
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
